import { isNaniStudy } from "./projectEnv";

const GA_ID = process.env.REACT_APP_GA_ID;

let _userRole = 'guest';

export const setUserRole = (role) => {
  if (!isNaniStudy) return;
  _userRole = role || 'guest';
};

const isReady = () => !!GA_ID && typeof window.gtag === 'function';

const send = (eventName, params) => {
  if (!isReady() || !isNaniStudy) return;
  window.gtag('event', eventName, { user_role: _userRole, ...params });
};

export const gaPageView = ({ page_location, page_title }) => {
  if (!isReady() || !isNaniStudy) return;
  // gtag('config') updates GA4's internal page context so all subsequent
  // events (click, video_complete, …) inherit the correct page_title.
  // gtag('event', 'page_view') alone does NOT update that context.
  document.title = page_title;
  window.gtag('config', GA_ID, {
    page_location,
    page_title,
    user_role: _userRole,
  });
};

export const gaClick = (params) => send('click', params);

export const gaVideoComplete = (params) => send('video_complete', params);

export const gaExamLinkOpen = (params) => send('exam_link_open', params);

export const gaPurchase = (params) => send('purchase', params);

export const gaRedemptionSubmit = (params) => send('redemption_submit', params);
